import { NavLink } from "react-router-dom";
import { House, BookOpen, Layers, Headphones, FlaskConical, CalendarClock, Mail, History, Languages } from "lucide-react";

const Octagram = (p) => (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinejoin="round" {...p}>
        <path d="M12 2.5l2.6 3.2 4.1-.4-.4 4.1 3.2 2.6-3.2 2.6.4 4.1-4.1-.4L12 21.5l-2.6-3.2-4.1.4.4-4.1L2.5 12l3.2-2.6-.4-4.1 4.1.4z" />
        <circle cx="12" cy="12" r="3.6" />
    </svg>
);

export const NAV_ITEMS = [
    { to: "/", label: ["Accueil"], icon: House, end: true, sep: true },
    { to: "/catalogue", label: ["Catalogue"], icon: BookOpen, sep: true },
    { to: "/ebooks", label: ["Ebooks"], icon: Layers, sep: true },
    { to: "/cours-audio", label: ["Cours", "audio"], icon: Headphones },
    { to: "/arabe-coranique", label: ["Arabe", "coranique"], icon: Octagram },
    { to: "/grammaire", label: ["Grammaire", "arabe"], icon: Languages },
    { to: "/a-propos", label: ["À propos"], icon: FlaskConical, sep: true },
    { to: "/rappel", label: ["Rappel", "du jour"], icon: CalendarClock },
    { to: "/contact", label: ["Contact"], icon: Mail },
];

function Item({ to, label, icon: Icon, end, isDark, testid }) {
    const idle = isDark ? "text-[rgba(244,238,223,0.85)] hover:text-[#E5C679]" : "text-[var(--text-primary)] hover:text-[var(--gold-600)]";
    const active = isDark ? "text-[#E5C679]" : "text-[var(--gold-600)]";
    return (
        <NavLink to={to} end={end} data-testid={testid}
            className={({ isActive }) => `nav-tile group relative flex flex-col items-center justify-center gap-1.5 h-[76px] px-2 min-[1400px]:px-3.5 2xl:px-5 rounded-t-2xl transition-colors duration-200 ${isActive ? active : idle}`}
            style={({ isActive }) => (isActive ? { background: isDark ? "rgba(229,198,121,0.10)" : "rgba(201,164,88,0.12)" } : undefined)}>
            {({ isActive }) => (
                <>
                    <Icon className="w-[22px] h-[22px] transition-transform duration-200 group-hover:-translate-y-0.5" strokeWidth={1.6} />
                    <span className="text-[12px] 2xl:text-[14px] font-medium leading-[1.1] text-center whitespace-nowrap">
                        {label.map((l) => <span key={l} className="block">{l}</span>)}
                    </span>
                    {isActive && <span className="absolute bottom-0 left-2 right-2 h-[3px] rounded-full" style={{ background: "var(--gold-400)" }} data-testid={`${testid}-active`} />}
                </>
            )}
        </NavLink>
    );
}

const Sep = ({ isDark }) => <span aria-hidden className="hidden 2xl:block w-px h-10 self-center" style={{ background: isDark ? "rgba(244,238,223,0.14)" : "rgba(11,15,26,0.10)" }} />;

export function HeaderNav({ isDark, showLibrary }) {
    return (
        <nav className="hidden xl:flex items-end self-end min-w-0" data-testid="header-nav">
            {NAV_ITEMS.map((it) => (
                <span key={it.to} className="flex items-center">
                    <Item {...it} isDark={isDark} testid={`nav-${it.to.replace(/\//g, "") || "home"}`} />
                    {it.sep && <Sep isDark={isDark} />}
                </span>
            ))}
            {showLibrary && <Item to="/library" label={["Reprendre"]} icon={History} isDark={isDark} testid="nav-library-link" />}
        </nav>
    );
}
